"use client";

import React from "react";
import { Quote } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TeamSection() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: cardRef,
    isVisible: isCardVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="team-section" className="py-16 bg-background overflow-hidden">
      <div className="page-container">
        {}
        <div ref={headerRef} className={`flex flex-col items-center text-center mb-16 transition-all duration-700 ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="w-12 h-0.5 bg-accent mb-6"></div>
          <span className="text-accent font-semibold tracking-widest text-sm uppercase mb-4">
            Ihr Ansprechpartner
          </span>
          <h2 className="font-default text-4xl md:text-5xl font-bold text-foreground mb-6">
            Persönliche Betreuung vom Fachmann
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Lernen Sie den Experten hinter Renovierungen Schneider kennen.
          </p>
        </div>

        {}
        <div ref={cardRef} className={`max-w-5xl mx-auto bg-card rounded-2xl shadow-lg border border-border/50 p-8 md:p-12 lg:p-16 flex flex-col md:flex-row items-center gap-12 lg:gap-16 transition-all duration-1000 delay-200 ${isCardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="w-full md:w-1/2 flex justify-center md:justify-end">
            <div className="relative w-64 h-64 rounded-lg overflow-hidden border-8 border-background shadow-xl shrink-0 group md:w-80 md:h-80 lg:w-96 lg:h-96 bg-cover bg-center !bg-[url(https://renovierungen-schneider.de/wp-content/uploads/2026/05/2-scaled.png)] !bg-[url(https://renovierungen-schneider.de/wp-content/uploads/2026/08/Gemini_Generated_Image_px2nedpx2nedpx2n.jpeg)]">
              
              
            </div>
          </div>

          {}
          <div className="w-full md:w-1/2 flex flex-col gap-6 text-center md:text-left">
            <div>
              <h3 className="font-default text-3xl lg:text-4xl font-bold text-foreground mb-2">A. Schneider</h3>
              <p className="text-accent font-medium text-lg lg:text-xl">
                Inhaber & Geschäftsführer
              </p>
            </div>

            <div className="w-16 h-px bg-border mx-auto md:mx-0"></div>

            <p className="text-muted-foreground leading-relaxed text-lg">
              Mit jahrelanger Erfahrung in der Baubranche stehe ich Ihnen als verlässlicher Partner zur Seite. Mein Ziel ist es, Ihre Visionen mit höchster handwerklicher Präzision und Qualität umzusetzen. Jeder Schritt Ihres Projekts wird von mir persönlich begleitet, um sicherzustellen, dass das Ergebnis Ihre Erwartungen übertrifft.
            </p>

            <blockquote className="relative bg-muted/30 rounded-xl p-6 mt-4 border-l-4 border-accent text-left">
              <Quote className="absolute top-4 right-4 w-8 h-8 text-accent/20" />
              <p className="italic text-foreground font-medium relative z-10 text-lg">
                "Qualität ist kein Zufall, sie ist immer das Ergebnis angestrengten Denkens und professioneller Umsetzung."
              </p>
            </blockquote>
          </div>
        </div>
      </div>
    </section>;
}